import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const AIChatButton: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 24)} fill="transparent">
            <Path
                d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L5 19L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
                stroke={props.color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path d="M15.1099 13V6H15.9799V13H15.1099Z" fill={props.color} />
            <Path
                d="M7.54809 13L10.0281 6H10.8381L13.3181 13H12.4281L11.8281 11.29H9.04809L8.45809 13H7.54809ZM9.30809 10.52H11.5581L10.6581 7.93C10.6348 7.86333 10.6081 7.78667 10.5781 7.7C10.5514 7.61 10.5248 7.52333 10.4981 7.44C10.4714 7.35333 10.4514 7.28 10.4381 7.22C10.4214 7.28 10.3998 7.35333 10.3731 7.44C10.3498 7.52333 10.3231 7.61 10.2931 7.7C10.2664 7.78667 10.2414 7.86333 10.2181 7.93L9.30809 10.52Z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(AIChatButton);
